import { useMemo } from 'react';

import { useMasterContext } from '&/master';

import type { MasterSelectionFilters } from '../lib/service-reminders-master-scope';
import { masterSelectionFilters } from '../lib/service-reminders-master-scope';

/**
 * The master selection (territory or location) as queue filters (decision #27), read from the shell's
 * `MasterContext`. Memoised on the two ids, so it is a stable value to merge into a request and a query key.
 */
export function useMasterSelectionFilters(): MasterSelectionFilters {
  const { siteId, territoryId } = useMasterContext();

  return useMemo(() => masterSelectionFilters({ siteId, territoryId }), [siteId, territoryId]);
}
